import { cn } from "@/lib/utils";
import { useState } from "react";

import { activeBrand } from "../../shared/brand";

export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6 shrink-0 text-primary", className)}
      viewBox={activeBrand.markViewBox}
    >
      <path d={activeBrand.markPath} fill="currentColor" fillRule="evenodd" />
    </svg>
  );
}

export function Brand({
  className,
  compact = false,
  suppressFallback = false,
  workspace,
}: {
  className?: string;
  compact?: boolean;
  suppressFallback?: boolean;
  workspace?: {
    name: string;
    logoSrc: string;
  };
}) {
  const [failedLogoSrc, setFailedLogoSrc] = useState<string | null>(null);

  if (workspace && failedLogoSrc !== workspace.logoSrc) {
    return (
      <span
        aria-label={workspace.name}
        className={cn("inline-flex items-center", className)}
        role="img"
      >
        <img
          alt=""
          className="h-9 max-w-40 object-contain"
          onError={() => {
            setFailedLogoSrc(workspace.logoSrc);
          }}
          src={workspace.logoSrc}
        />
      </span>
    );
  }

  if (suppressFallback) {
    return <span aria-hidden="true" className={cn("inline-flex h-9 w-40", className)} />;
  }

  return (
    <span
      aria-label={activeBrand.name}
      className={cn("inline-flex items-center", className)}
      role="img"
    >
      {compact ? (
        <BrandMark />
      ) : (
        <img alt="" className="h-10 w-auto max-w-44 object-contain" src={activeBrand.assets.logo} />
      )}
    </span>
  );
}
